const ZegoLayoutMode = {
    pictureInPicture: 0,
    gallery: 1
}
const ZegoViewPosition = {
    topLeft: 0,
    topRight: 1,
    bottomLeft: 2,
    bottomRight: 3
}

export { ZegoLayoutMode, ZegoViewPosition };